import React from 'react';

import { useIntl } from 'react-intl';

import CopyingTextToClipboard from 'components/CopyingTextToClipboard';
import { Typography, Grid } from 'e100-react-components';
import { useSelectedMobileLocation } from 'features/myFleet/store';

const AutoNumber = () => {
  const { formatMessage } = useIntl();
  const { autoNumber } = useSelectedMobileLocation() || {};

  return (
    <Grid item xs={12}>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant={'h6'} gutterBottom>
            {formatMessage({ id: 'auto' })}:{' '}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant={'h6'} gutterBottom>
            <CopyingTextToClipboard>{autoNumber || ''}</CopyingTextToClipboard>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AutoNumber;
